module.exports = __webpack_public_path__ + "img/about/80243-045.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-045.png
// module id = 43
// module chunks = 0